import React, { useEffect, useState, useRef } from "react";
import { apiClient } from "../../utils/apiClient";
import { renderContent } from "./broker-banner.utils";
import Modal from "../modal/modal.component";


const getMediaUrl = (url) => {
  //return `https://dev.intermediaries.hsbc.co.uk${url}`;
  return url;
};

const MediaElement = ({ mediaUrl, mediaAltText }) => {
  return <img src={mediaUrl} alt={mediaAltText || ""} />;
};

const BrokerBanner = () => {
  const [item, setItem] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mediaObjectUrl, setMediaObjectUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await apiClient.get("banners/current?type=Broker");

        if (response) {
          const {
            textBoxColor,
            content,
            ctaButtonLabel,
            ctaButtonUrl,
            media,
            background,
            backgroundAltText,
            mediaPosition,
            imageTextRatio,
            overlayPadding,
          } = response;

          if (background?.url) {
            setMediaObjectUrl(getMediaUrl(background.url));
          }

          setItem({
            textBoxColor,
            content: JSON.parse(content)?.content,
            ctaButtonLabel,
            ctaButtonUrl: media?.url ? getMediaUrl(media.url) : ctaButtonUrl,
            hasPdf: !!media?.url,
            mediaAltText: backgroundAltText,
            mediaPosition,
            imageTextRatio,
            overlayPadding,
          });
          setLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch broker banner data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return null;
  }

  if (!item.content) {
    return null;
  }

  const mediaFlexBasis = item.mediaPosition === "right"
    ? item.imageTextRatio?.split("-")[1]
    : item.imageTextRatio?.split("-")[0];

  const contentFlexBasis = item.mediaPosition === "right"
    ? item.imageTextRatio?.split("-")[0]
    : item.imageTextRatio?.split("-")[1];



  return (
    <>
      <div className="col-xs-12 col-xl-6">
        <div className="broker-banner">
          <div
            className="broker-banner__container"
            data-media-position={item.mediaPosition}
          >
            {mediaObjectUrl && (
              <div
                className="broker-banner__media"
                style={{ flex: `0 0 ${mediaFlexBasis}%` }}
              >
                <MediaElement
                  mediaUrl={mediaObjectUrl}
                  mediaAltText={item.mediaAltText}
                />
              </div>
            )}
            <section
              className="broker-banner__content"
              style={{
                backgroundColor: item.textBoxColor,
                padding: item.overlayPadding,
                flex: !mediaObjectUrl ? '1' : `0 0 ${contentFlexBasis}%`,
              }}
            >
              {renderContent(item.content.blocks || [])}
              {item.ctaButtonLabel && (
                <div className="broker-banner__button-wrapper">
                  <div

                    className="broker-banner__button"
                    onClick={() => {
                      if (item.hasPdf) {
                        setIsModalOpen(true);
                      } else {
                        window.open(item.ctaButtonUrl, '_blank', 'noopener,noreferrer');
                      }
                    }}
                  >
                    {item.ctaButtonLabel}
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)} isPdfPreview={true}>
        <iframe
          src={isModalOpen ? `${window.location.origin}/${item.ctaButtonUrl}` : ''}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title="PDF Viewer"
        />
      </Modal >
    </>
  );
};

export default BrokerBanner;
